/* eslint-disable no-unused-vars */
export enum Permission {
	OWNER = 'OWNER',
	MANAGE = 'MANAGE',
	WRITE = 'WRITE',
	READ = 'READ',
	NONE = 'NONE',
}
